import { NgModule, InjectionToken } from '@angular/core';
import { environment } from '../environments/environment';
export let APP_CONFIG = new InjectionToken<AppConfig>('app.config');

export class AppConfig {
  apiEndpoint: string;
  documentEndpoint: string;
  adfsEndpoint: string;
  apiTimeout: number;
  apiRetry: number;
  runmode: string;
  permissionCode: { [key: string]: string };
  group: { [key: string]: string };
  application: { [key: string]: string };
  consentEndpoint: string;
  consentDataId: string;
  consentDataWorkspaceId: string;
  consentDsrmDataId: string;
  cookieEndpoint: string;
  cookieDataId: string;
  identityProviderType: string;
  postfixEmail:string;
  reportApiEndpoint:string;
  defaultLanguage :string;
  exportLimit: number;
  mailMaxFileSize: number;
  apiDigitalMailboxTimeout: number;
  printAndPostEndpoint: string;
  printAndPostUrlEndpoint: string;
  urlKtbEndpoint: string;
  tutorialUrl: string;
  helpdeskQueryParams: string;
}

export const APP_DI_CONFIG: AppConfig = {
  apiEndpoint: environment.apiEndpoint,
  documentEndpoint: environment.documentEndpoint,
  apiTimeout: environment.apiTimeout,
  apiRetry: environment.apiRetry,
  runmode: environment.runmode,
  permissionCode: environment.permissionCode,
  group: environment.group,
  application: environment.application,
  adfsEndpoint: environment.adfsEndpoint,
  consentEndpoint: environment.consentEndpoint,  
  consentDataId: environment.consentDataId,
  consentDataWorkspaceId: environment.consentDataWorkspaceId,
  consentDsrmDataId: environment.consentDsrmDataId,
  cookieEndpoint: environment.cookieEndpoint,
  cookieDataId: environment.cookieDataId,
  identityProviderType: environment.identityProviderType,
  postfixEmail:environment.postfixEmail,
  reportApiEndpoint:environment.reportApiEndpoint,
  defaultLanguage :environment.defaultLanguage,
  exportLimit : environment.exportLimit,
  mailMaxFileSize : environment.mailMaxFileSize,
  apiDigitalMailboxTimeout :  environment.apiDigitalMailboxTimeout,
  printAndPostEndpoint: environment.printAndPostEndpoint,
  printAndPostUrlEndpoint: environment.printAndPostUrlEndpoint,
  urlKtbEndpoint: environment.urlKtbEndpoint,
  tutorialUrl: environment.tutorialUrl,
  helpdeskQueryParams: environment.helpdeskQueryParams,
};

@NgModule({
  providers: [
    {
      provide: APP_CONFIG,
      useValue: APP_DI_CONFIG,
    },
  ],
})
export class AppConfigModule {}
